module.exports = __webpack_public_path__ + "11_hige_white.623eb591.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/11_hige_white.png
// module id = WF1O
// module chunks = 0